if (!customElements.get("product-review-table")) {
    customElements.define(
        "product-review-table",
        class ProductReviewTable extends HTMLElement {
            reviews = []
            pages = []
            perPage = undefined
            currentPage = 1;
            parentID = null;
            constructor() {
                super();

                const config = theme.utils.parseJSON(this.dataset.config, true) ?? {}

                this.reviews = this.querySelectorAll(".product-review-table__review");
                this.pages = this.querySelectorAll(".product-review-table__page");

                this.perPage = config.perPage || Math.ceil(this.reviews.length / this.pages.length);
                this.parentID = config.parentID ?? null;

                for(const [index, element] of this.pages.entries()){
                    element.addEventListener('click', () => {
                        this.setPage(element, index + 1)
                    });
                }
            }

            setPage(button, number){
                button.classList.add("active");
                this.pages?.forEach((e) => {
                    if(e !== button){
                        e.classList.remove("active");
                    }
                })
                this.currentPage = number;

                this.reviews.forEach((element, i) => {
                    const page = Math.ceil((i + 1) / this.perPage);
                    element.hidden = page !== this.currentPage
                });

                const anchorElement = this.parentID ? document.querySelector(`#${this.parentID}`) ?? this : this

                window.scrollTo({
                    top: anchorElement.getBoundingClientRect().top + window.pageYOffset - theme.utils.getHeaderHeight(),
                    behavior: 'smooth'
                })
            }
        },
    );
}
